import { httpGet, httpPost, httpPut, httpDelete } from "../utils/http";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  getSetting(clinic) {
    let clinicID = clinic ? clinic : localStorage.getItem("CLINIC");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${clinicID}/setting`;
    return httpGet(apiUrl);
  }

  updateSetting(setting) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/setting`;
    return httpPut(apiUrl, setting);
  }

  updateOrderSeries(orderSeries) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/setting`;
    return httpPut(apiUrl, { orderSeries });
  }

  getTreatmentSetting() {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/setting/treatment`;
    return httpGet(apiUrl);
  }

  updateTreatmentSetting(updated) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/setting/treatment`;
    return httpPut(apiUrl, updated);
  }

  updatePrintSetting(updated) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/setting/print`;
    return httpPut(apiUrl, updated);
  }

  getBackupUrl() {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/setting/clinicBackup`;
    return httpGet(apiUrl);
  }
}
